/*eslint-disable no-undef*/

__webpack_public_path__ = window.remoteUrl;

require('./chunks/critical_path');
require('grpn-gig-components/lib/components/alerts/alerts');
const { windowLoaded } = require('@grpn/document-states');

windowLoaded.then(() => {
  Groupon.Performance.pageReady(true); // fire boomerang
  Groupon.Performance.pageReady = () => {}; // render function useless for ITA
});

/*eslint-disable no-undef*/
windowLoaded.then(() => {
  import(/* webpackChunkName: 'desktop-preact' */ './chunks/desktop-preact');
  import(/* webpackChunkName: 'desktop-misc-v7' */ './desktop-misc');
});
